<template>
  <div class="lessons text-dark">
    <div class="lessons__filters">
      <div class="lessons__filters__filter"
           :class="{'lessons__filters__filter--active': activeFilter === 'lessonsWithoutSub'}"
           @click="setFilter('lessonsWithoutSub')">{{ $t('vue2.substitution.lessons_without_sub') }}
        ({{ eventsWithoutSubstitute.length }})
      </div>
      <div class="lessons__filters__filter"
           :class="{'lessons__filters__filter--active': activeFilter === 'lessonsWithSub'}"
           @click="setFilter('lessonsWithSub')">{{ $t('vue2.substitution.lessons_with_sub') }}
        ({{ eventsWithSubstitute.length }})
      </div>
      <div class="lessons__filters__filter"
           :class="{'lessons__filters__filter--active': activeFilter === ''}"
           @click="setFilter('')">{{ $t('vue2.substitution.all_lessons') }} ({{ events.length }})
      </div>
    </div>
    <div v-if="isLoading">
      <Loader style="margin-top: 10rem" :isSmall="true"></Loader>
    </div>
    <div class="no-lessons-text" v-if="!isLoading && eventsSortedInDays.length < 1">
      <h4 class="text-explainer">
        <span v-if="activeFilter === 'lessonsWithoutSub'">{{ $t('vue2.substitution.no_lessons_without_subs') }}</span>
        <span v-if="activeFilter === 'lessonsWithSub'">{{ $t('vue2.substitution.no_lessons_with_sub') }}</span>
        <span v-if="activeFilter === ''">{{ $t('vue2.substitution.no_lessons') }}</span>
      </h4>
    </div>
    <div v-if="!isLoading && eventsSortedInDays.length > 0" class="marg-1-top">
      <div class="subs-days-container__header">
        <p class="select-all-item" @click="toggleAll">
          <span v-if="eventIdsToAddSub.length === 0">{{ $t('vue2.subs_ongoing_absence.select_all') }}</span>
          <span v-else>{{ $t('vue2.subs_ongoing_absence.unselect_all') }}</span>
        </p>
        <p class="select-all-item" @click="toggleAll">
        </p>
      </div>
      <ul class="subs-days-container rounded shadow">
        <li v-for="day in eventsSortedInDays">
          <div class="day__header">
            <label>{{ day.date | ddd | capitalize }}, {{ day.date | LL }}</label>
          </div>
          <ul class="sub-lessons">
            <li v-for="event in day.events"
                :key="event.event_id"
                class="d-lesson"
                :class="{'d-lesson--active': isInEventIdsToAddSub(event.event_id) || (activeLesson && event.event_id === activeLesson.event_id)}"
                :style="{'border-color': event.color}"
                @click.stop.prevent="toggleEvent(event.event_id)">
              <div class="d-lesson__left">
                <div class="d-checkbox" :class="{'d-checkbox--active': isInEventIdsToAddSub(event.event_id)}"></div>
                <div class="d-lesson__title">
                  <span class="d-lesson__time">{{ event.start | LT }} - {{ event.end | LT }}</span>
                  {{ event.title }}
                  <span v-for="klass in getClasses(event)">, {{ klass.name }}</span>
                  <p
                </div>
              </div>
              <div class="sub-selector" @click.stop>
                <span class="icon-users" v-if="getSubstitute(event).length > 0"></span>
                <p v-for="sub in getSubstitute(event)" class="sub-name">
                  <b>{{ sub.name }}</b>
                  <span class="icon-cross2" @click="setIsAskRemoveAll(true, event, sub)"></span>
                </p>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <DModal v-if="isAskRemoveAll" :show-close="false">
      <div slot="insertComponent">
        <div class="d-modal__header">
          <h2>{{ $t('vue2.substitution.remove_sub_from_all_lessons') }}?</h2>
          <div class="font-large icon__bg-circle d-modal__header__close"
               @click="setIsAskRemoveAll(false, null, null)"><span
            class="icon-cross2"></span></div>
        </div>
        <div class="d-modal__body">
          <h4>{{ $t('vue2.substitution.do_you_want_to_remove') }} {{ activeSub.name }}
            {{ $t('vue2.substitution.as_sub_on') }} "<span><span
              class="d-lesson__time">{{ activeLesson.start | LT }} - {{
                activeLesson.end | LT
              }}</span>{{ activeLesson.title }}<span v-for="klass in getClasses(activeLesson)">, {{
                klass.name
              }}</span></span>" -
            {{ $t('vue2.substitution.or_on_all_lessons') }}?
          </h4>
          <div class="d-modal__buttons">
            <button class="marg-10-right" @click="removeSubFromAllLessons">
              {{ $t('vue2.substitution.remove_from_all_lessons') }}
            </button>
            <button class="submit-button" @click="removeSubFromActiveLesson">
              {{ $t('vue2.substitution.just_this_lessons') }}
            </button>
          </div>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import moment from 'moment'
import {mapGetters} from 'vuex'
import docendo from '../../../docendo'
import Loader from '../../common/Loader'
import DModal from '../../common/DModal'

export default {
  components: {DModal, Loader},
  props: {
    calendarId: {},
    dates: {
      default: () => []
    },
    subToAdd: {
      type: Object,
      default: null
    },
    isSubStatusPendingActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      events: [],
      selectedEvents: [],
      eventIdsToAddSub: [],
      activeFilter: 'lessonsWithoutSub',
      dbEventsWithSubs: [],
      isAskRemoveAll: false,
      activeLesson: null,
      activeSub: null
    }
  },
  watch: {
    subToAdd (val, oldVal) {
      if (val) {
        this.addSubstitute(this.subToAdd)
      }
    },
    eventIdsToAddSub () {
      this.$emit('changed', this.eventIdsToAddSub)
    },
    dates () {
      this.getAllEventsInRanges()
    }
  },
  computed: {
    ...mapGetters([
      'allCalendarsInHash',
      'allUsersInCalIdHash',
      'allKlassCalendarsInHash',
      'longAbsentListInHash',
      'activeAbsentUserOriginalEventsInHash'
    ]),
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    filteredEvents () {
      if (this.activeFilter === 'lessonsWithoutSub') {
        return this.events.filter(event => !this.getEventHasSub(event))
      } else if (this.activeFilter === 'lessonsWithSub') {
        return this.events.filter(event => this.getEventHasSub(event))
      } else {
        return this.events
      }
    },
    sortedEvents () {
      let arr = this.filteredEvents
      if (arr.length < 1) {
        return []
      }
      return arr.sort((a, b) => {
        return moment(a.start).unix() - moment(b.start).unix()
      })
    },
    eventsSortedInDays () {
      if (this.sortedEvents.length < 1) {
        return []
      }
      let sortedEventsInDays = this.sortedEvents.reduce((acc, curr, index) => {
        let val = moment(curr['start']).format('YYYY-MM-DD')
        acc[val] = acc[val] || []
        acc[val].push(curr)
        return acc
      }, {})
      return this.eventsToArr(sortedEventsInDays)
    },
    eventsWithoutSubstitute () {
      let events = this.events.filter(lesson => !this.getEventHasSub(lesson))
      return events.map(event => event.event_id)
    },
    eventsWithSubstitute () {
      let events = this.events.filter(lesson => this.getEventHasSub(lesson))
      return events.map(event => event.event_id)
    }
  },
  methods: {
    getEventHasSub (event) {
      let hasSub = false
      event.calendars.forEach(calendar => {
        if (calendar.substitute && calendar.substitute === this.allUsersInCalIdHash[this.calendarId].id) {
          hasSub = true
        }
      })
      return hasSub
    },
    setFilter (filter) {
      this.eventIdsToAddSub = []
      this.activeFilter = filter
    },
    setDbDateTime (inputDate, dayTime) {
      let date = moment(inputDate).format('YYYY-MM-DD')
      let time = moment(dayTime)
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    readEvents (start, end) {
      this.eventIdsToAddSub = []
      this.isLoading = true

      const dbStart = this.setDbDateTime(start, moment().startOf('day'))
      const dbEnd = this.setDbDateTime(end, moment().endOf('day'))

      docendo.eventsFromCalendars([this.calendarId], dbStart, dbEnd, null, success => {
        // Håndter både string og array respons
        let data = []
        if (Array.isArray(success)) {
          data = success
        } else if (typeof success === 'string' && success.length > 0) {
          try {
            data = JSON.parse(success)
          } catch (e) {
            console.log('JSON parse failed', e)
            data = []
          }
        }

        // Tilføj nye, gyldige events
        data.forEach(lesson => {
          const idx = this.events.findIndex(event => event.event_id === lesson.event_id)
          if (
            idx < 0 &&
            lesson.event_type !== 'absence' &&
            lesson.event_type !== 'presence' &&
            lesson.event_type !== 'reservation' &&
            !lesson.canceled &&
            !lesson.away
          ) {
            this.events.push(lesson)
          }
        })

        // Markér alle events uden vikar som selected
        this.events.forEach(lesson => {
          if (!this.getEventHasSub(lesson)) {
            if (this.eventIdsToAddSub.indexOf(lesson.event_id) < 0) {
              this.eventIdsToAddSub.push(lesson.event_id)
            }
          }
        })

        this.$emit('gotLessons', true)
        this.$store.commit('setActiveAbsentUserEvents', this.events)
        // Deep copy
        this.$store.commit('setActiveAbsentUserOriginalEvents', JSON.parse(JSON.stringify(this.events)))

        setTimeout(_ => {
          this.isLoading = false
        }, 500)
      }, failure => {
        console.log('failed', failure)
        this.$emit('gotLessons', false)
        setTimeout(_ => {
          this.isLoading = false
        }, 0)
      })
    },
    eventsToArr (events) {
      return Object.keys(events).map(e => {
        return {date: e, events: events[e]}
      })
    },
    getSubstitute (event) {
      let subs = event.calendars.filter(calendar => calendar.substitute === this.allUsersInCalIdHash[this.calendarId].id)
      return subs.map(calendar => this.allUsersInCalIdHash[calendar.calendar_id])
    },
    getClasses (event) {
      return event.calendars.filter(cal => cal.calendar_type === 'klass')
    },
    isInEventIdsToAddSub (eventId) {
      let idx = this.eventIdsToAddSub.indexOf(eventId)
      return idx > -1
    },
    toggleEvent (eventId) {
      let idx = this.eventIdsToAddSub.indexOf(eventId)
      if (idx < 0) {
        this.eventIdsToAddSub.push(eventId)
      } else {
        this.eventIdsToAddSub.splice(idx, 1)
      }
    },
    toggleAll () {
      if (this.eventIdsToAddSub.length > 0) {
        this.eventIdsToAddSub = []
        this.selectedEvents = []
      } else {
        // måske lave noget med (alle uden vikarer)
        this.events.forEach(event => {
          this.eventIdsToAddSub.push(event.event_id)
          this.selectedEvents.push(event)
        })
      }
    },
    getAllEventsInRanges () {
      this.events = []
      this.$store.commit('setActiveAbsentUserEvents', [])
      this.dates.forEach(range => {
        let moments = range.map(d => moment(d))
        let startDate = moment.min(moments)
        let endDate = moment.max(moments)
        this.readEvents(moment(startDate).startOf('day'), moment(endDate).endOf('day'))
      })
    },
    addSubstitute (user) {
      // Tilføj vikar på alle lektioner
      this.eventIdsToAddSub.forEach(eventId => {
        let idx = this.events.findIndex(event => event.event_id === eventId)
        let calendar = {
          calendar_id: user.user_calendar_id,
          substitute: this.allUsersInCalIdHash[this.calendarId].id,
          // minutes is hardcoded
          minutes: 60
        }
        let calIdx = this.events[idx].calendars.findIndex(calendar => calendar.calendar_id === user.user_calendar_id)
        // Hvis brugeren allerede er på lektionen, så behold personen der i stedet for vikar
        if (calIdx < 0) {
          this.events[idx].calendars.push(calendar)
          // If sub is deleted from original event then clean up arr to db
          let dbArrIdx = this.dbEventsWithSubs.findIndex(obj => obj.event_id === eventId && obj.calendar === this.calendarId && obj.remove_substitute_calendar_id === user.user_calendar_id)
          if (dbArrIdx < 0) {
            const updateObj = {
              event_id: eventId,
              calendar_id: this.calendarId,
              add_substitute_calendar_id: user.user_calendar_id
            }
            if (this.isSubStatusPendingActive) {
              let statusData = {}
              statusData[this.calendarId] = {'status': 2}
              updateObj['substitution_status'] = JSON.stringify(statusData)
            }
            this.dbEventsWithSubs.push(updateObj)
          } else {
            this.dbEventsWithSubs.splice(dbArrIdx, 1)
          }
        }
      })
      this.$emit('updatedArr', this.dbEventsWithSubs)
      this.eventIdsToAddSub = []
    },
    setIsAskRemoveAll (boolean, lesson, sub) {
      this.isAskRemoveAll = boolean
      this.activeLesson = lesson
      this.activeSub = sub
    },
    removeSubFromAllLessons () {
      // Find alle lektioner, hvor han er på som vikar for personen
      let sub = this.activeSub
      this.events.forEach(event => {
        let calIdx = event.calendars.findIndex(calendar => calendar.calendar_id === sub.user_calendar_id && calendar.substitute === this.allUsersInCalIdHash[this.calendarId].id)
        if (calIdx > -1) {
          this.removeSub(event, sub)
        }
      })
      this.isAskRemoveAll = false
      this.activeLesson = null
      this.activeSub = null
    },
    removeSubFromActiveLesson () {
      this.removeSub(this.activeLesson, this.activeSub)
      this.isAskRemoveAll = false
      this.activeLesson = null
      this.activeSub = null
    },
    removeSub (lesson, sub) {
      // Remove in frontend data
      let eventIdx = this.events.findIndex(event => event.event_id === lesson.event_id)
      let calIdx = this.events[eventIdx].calendars.findIndex(calendar => calendar.calendar_id === sub.user_calendar_id && calendar.substitute === this.allUsersInCalIdHash[this.calendarId].id)
      this.events[eventIdx].calendars.splice(calIdx, 1)
      // If sub is on original event then tell server to remove sub
      let statusData = {}
      statusData[this.calendarId] = {'status': 0}
      let origCalIdx = this.activeAbsentUserOriginalEventsInHash[lesson.event_id].calendars.findIndex(calendar => calendar.calendar_id === sub.user_calendar_id && calendar.substitute === this.allUsersInCalIdHash[this.calendarId].id)
      if (origCalIdx > -1) {
        // See if sub is already removed in frontend
        this.dbEventsWithSubs.push({
          event_id: lesson.event_id,
          calendar_id: this.calendarId,
          remove_substitute_calendar_id: sub.user_calendar_id,
          substitution_status: JSON.stringify(statusData)
        })
      } else {
        let dbEventsIdx = this.dbEventsWithSubs.findIndex(event => event.event_id === lesson.event_id && event.add_substitute_calendar_id === sub.user_calendar_id)
        this.dbEventsWithSubs.splice(dbEventsIdx, 1)
      }
      this.$emit('updatedArr', this.dbEventsWithSubs)
    }
  },
  mounted () {
    this.getAllEventsInRanges()
  },
  beforeDestroy () {
    this.events = []
    this.$store.commit('setActiveAbsentUserEvents', [])
  }
}
</script>

<style scoped>
@import "../../../../src/assets/css/variables.css";

.day__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-color);
  padding: 0.5rem 1rem;
  background: #f9fafb;
}

.day__header label {
  font-size: .9rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #697386;
  padding: 0.25rem 0;
}

.sub-lessons li:not(:last-child) {
  border-bottom: 1px solid var(--border-color) !important;
}

.d-lesson {
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  cursor: pointer;
  background: #ffffff;
  border-left: 2px solid;
}

.d-lesson__title {
  display: flex;
  align-items: center;
}

.d-lesson__time {
  font-size: 0.9rem;
  margin-right: 0.5rem;
}

.sub-lessons li.d-lesson.d-lesson--active {
  background: aliceblue;
}

.select-all-item {
  cursor: pointer;
  color: var(--blue);
}

.select-all-item:hover {
  text-decoration: underline;
}

.sub-selector {
  display: flex;
  align-items: center;
}

.d-lesson__left {
  display: flex;
  align-items: center;
}

.d-checkbox {
  position: relative;
  margin-left: 0;
  margin-right: 1rem;
  height: 12px;
  width: 12px;
  border: 1px solid var(--border-color);
  border-radius: 2px;
  padding: 2px;
}

.d-checkbox.d-checkbox--active {
  background: var(--blue);
  border-color: var(--blue);
}

.d-checkbox:after, .d-checkbox:before {
  transform: rotate(35deg);
}

.d-checkbox:after {
  content: '';
  display: block;
  width: 2px;
  height: 8px;
  background: #ffffff;
  position: absolute;
  top: 1px;
  right: 3px;
}

.d-checkbox:before {
  content: '';
  display: block;
  width: 4px;
  height: 2px;
  background: #ffffff;
  position: absolute;
  bottom: 3px;
  right: 5px;
}

.subs-days-container__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subs-days-container__header label {
  color: #808692;
  font-weight: normal;
  font-size: 1rem;
}

.lessons__filters {
  display: flex;
}

.lessons__filters__filter {
  padding: 0.5rem 2rem;
  border: 1px solid var(--border-color);
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.25s;
  user-select: none;
}

.lessons__filters__filter:active {
  transform: scale(0.98);
}

.lessons__filters__filter.lessons__filters__filter--active {
  color: var(--blue);
}

.lessons__filters .lessons__filters__filter:first-child {
  border-radius: 4px 0 0 4px;
}

.lessons__filters .lessons__filters__filter:last-child {
  border-radius: 0 4px 4px 0;
}

.no-lessons-text {
  padding: 2rem 0;
}

.sub-name {
  border: 1px solid var(--border-color);
  border-radius: 50px;
  padding: 0 1rem;
  display: flex;
  align-items: center;
}

.sub-name span {
  margin-left: 5px;
}

.sub-name span:hover {
  color: var(--blue);
}

</style>



// WEBPACK FOOTER //
// SubsUserPanelLessons.vue?d8299c16